import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200120Status: 'idle',
    startProcess200120Error: undefined as any,
    loadUserParamsProcess200120Status: 'idle',
    loadUserParamsProcess200120Error: undefined as any,

    process200120List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200120 = createAsyncThunk('process200120Slice/startProcess200120', async ({ process200120 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200120/`,
        prepareData(process200120),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200120Status } = getState().process200120Slice
        return startProcess200120Status !== 'pending'
    }
})

export const loadUserParamsProcess200120 = createAsyncThunk('process200120Slice/loadUserParamsProcess200120', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200120/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200120Status } = getState().process200120Slice
        return loadUserParamsProcess200120Status !== 'pending'
    }
})

const Process200120Slice = createSlice({
    name: 'process200120Slice',
    initialState,
    reducers: {
        resetstartProcess200120: (state) => {
            state.job = undefined
            state.startProcess200120Error = undefined
        },
        resetstartProcess200120Error: (state) => {
            state.startProcess200120Error = undefined
        },
        resetloadUserParamsProcess200120: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200120Error = undefined
        },
        resetloadUserParamsProcess200120Error: (state) => {
            state.loadUserParamsProcess200120Error = undefined
        },
        removeFromProcess200120ListById: (state, action) => {
            state.process200120List = state.process200120List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200120ListByIds: (state, action) => {
            state.process200120List = state.process200120List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200120List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200120Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200120List = []
            state.startProcess200120Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200120.pending, (state) => {
            state.startProcess200120Status = 'pending'
            state.startProcess200120Error = undefined
        })
        builder.addCase(startProcess200120.fulfilled, (state, action) => {
            state.startProcess200120Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200120.rejected, (state, action) => {
            state.startProcess200120Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200120Error = action.error.message
            } else {
                state.startProcess200120Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200120.pending, (state) => {
            state.loadUserParamsProcess200120Status = 'pending'
            state.loadUserParamsProcess200120Error = undefined
        })
        builder.addCase(loadUserParamsProcess200120.fulfilled, (state, action) => {
            state.loadUserParamsProcess200120Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200120.rejected, (state, action) => {
            state.loadUserParamsProcess200120Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200120Error = action.error.message
            } else {
                state.loadUserParamsProcess200120Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200120,
    resetstartProcess200120Error,
    resetloadUserParamsProcess200120,
    resetloadUserParamsProcess200120Error,
    removeFromProcess200120ListById,
    removeFromProcess200120ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200120Slice.actions
export default Process200120Slice.reducer
